<div class="card overflow-hidden rounded-10 shadow">
  <div class="card-body" *ngIf="isLoaded">
    <app-loading-dash [size]="'card-middle'" />
  </div>
  <div class="card-body" *ngIf="!isLoaded">
    <div class="card-widget">
      <h6 class="mb-3">{{ 'common.receivedSales' | translate }}</h6>
      <h2 class="text-end">
        <i
          class="mdi mdi-cash-multiple icon-size float-start purple-color ajuste-icone"
        ></i
        ><span class="number-font"
          >
          {{
            sumSales
              | formatCurrency
          }}</span
        >
      </h2>
      <p class="mb-0">
        (%) {{ 'common.comparedLastWeek' | translate }}<span class="float-end"
          >{{
            sumSalesPercent
              | mask : "separator.2" : { decimalMarker: ",", leadZero: true }
          }}%</span
        >
      </p>
    </div>
  </div>
</div>
